<template>
  <div>
    <b-modal  @hide="hide" id="editModalUser" size="xl" title="Yönetici Düzenle" @show="detail" hide-footer>
      <b-form @submit="onSubmit" >

        <div class="row">
          <div class="col-md-6">
            <b-form-group label="Kullanıcı Adı">
              <b-input v-model="username" required></b-input>
            </b-form-group>
          </div>
          <div class="col-md-6">
            <b-form-group label="Şifre">
              <b-input v-model="password" type="password"></b-input>
            </b-form-group>
          </div>
            <div class="col-md-12">
                <b-form-group label="Yetkilendirilecek Site Seçin">
                    <v-select multiple="" label="name" :filterable="false" :options="sites"  class="form-control text-white"
                              v-model="site_id">
                        <template slot="option" slot-scope="option">
                            {{ option.site_name }}
                        </template>
                        <template slot="selected-option" slot-scope="option">
                            <div class="selected d-center">
                                {{ option.site_name }}
                            </div>
                        </template>
                    </v-select>
                </b-form-group>
            </div>
            <div class="col-md-6">
            <b-form-group label="Authenticator QR">
              <img :src="authenticator_code" alt="">
            </b-form-group>
          </div>
        </div>
        <hr>
        <div class="d-flex justify-content-center" v-if="!loading">
          <b-button type="submit" variant="success" class=""> <i class="fas fa-check" /> Kaydet</b-button>
        </div>
        <div class="d-flex justify-content-center" v-if="loading">
          <b-button type="submit" variant="success" class="" disabled> <span>  <i class="fas fa-spinner fa-spin"></i></span> </b-button>
        </div>
      </b-form>




    </b-modal>
  </div>
</template>

<script>
import settingsService from "@/services/settingsService";
import sitesService from "@/services/sitesService";

export default {
  name: "UserEdit",
  data() {
    return {
      loading: false,
      username: '',
      password: '',
      authenticator_code: '',
      res: '',
      site_id: '',
      sites: []
    }
  },
  props: ['id'],
  methods: {
    hide() {
      this.username = ''
      this.password = ''
      this.authenticator_code = ''
    },
    onSubmit(event) {
      event.preventDefault()
      this.loading = true
      settingsService.editAdmin({
        username: this.username,
        password: this.password,
        id: this.id,
        sites: this.site_id
      })
          .then((res) => {
            this.loading = false
            if(res.state){
              this.$store.dispatch('getNotifyMessage', {siteConfirm: true, show: true, icon: 'success', title: 'Başarıyla Düzenlendi.', message: ''})
              this.$bvModal.hide('editModalUser')
              this.$store.dispatch('getRefresh', true)
            }else{
              this.$store.dispatch('getConfirmMessage', {show: true, icon: 'error', title: 'Ops!', message: res.message})
            }
          })
    },
    detail(){
      this.loading = true
      settingsService.adminDetail({id: this.id})
      .then((res) => {
        this.loading = false
        this.res = res

        if(res.state){

          this.username = res.data.username
          this.authenticator_code = res.authenticator_code
          this.site_id = res.data.sites
          this.getSites()
        }else {
          this.$store.dispatch('getConfirmMessage', {show: true, icon: 'error', title: 'Ops!', message: res.message})
        }
      })
    },
    getSites(){
          this.loading = true
          sitesService.get({status: true})
              .then((res) => {
                  this.loading = false
                  if(res.state){
                      this.sites = res.data
                  }else{
                      this.$store.dispatch('getConfirmMessage', {stop_with_mail: this.stop_with_mail, show: true, icon: 'error', title: 'Ops!', message: res.message})
                  }
              })
      }
  }
}
</script>

<style scoped>

</style>